import React, {Component} from 'react';
import {List, Picker,Toast,NavBar,InputItem,Modal} from 'antd-mobile';
import './index.less';
import {driver,confirmOrder,cancelRent,orderDetail} from "../../../service/rentService";
import {connect} from "react-redux";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class RentConfirm extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            driverData:[],
            driver:'',
            car:'',
            carData:[],
            people:this.props.location.shuntType.passagerNum ? this.props.location.shuntType.passagerNum : '',
            price:'',
            driverId:'',
            carId:'',
            orderData:{},
            showModal:false,
            orderId:'',
        };
    }

    componentDidMount() {
        this.getDriver();
        // this.rentDetail();
    }
    // rentDetail = () =>{
    //     let params = {
    //         token: this.props.userInfo.token,
    //         "data":{
    //             "id":this.props.location.state.id,
    //         }
    //     };
    //     orderDetail(params)
    //         .then((res) => {
    //             console.log(res)
    //             if (res.data.code === '0000') {
    //                 this.setState({
    //                     orderData:res.data.data
    //                 })
                   
    //              }
    //              else if (res.data.code === '1401') {
    //                 document.location = `js://toLogin?token=${this.props.userInfo.token}`;
    //              }
    //              else {
    //                  Toast.info(res.data.msg);
    //              }
    //         }).catch(function (error) {
    //     });
    // }
    /* 获取司机和车牌 */
    getDriver = () =>{
        let params={
            token: this.props.userInfo.token,
        };
        driver(params).then((res) => {
            if(res.data.code == "0000"){
                console.log(res)
                let driverData = [];
                res.data.data.map((res) => {
                    driverData.push({
                        label:res.driverName,
                        value:res.driverName,
                        driverId:res.driverId,
                        carInformationList:res.carInformationList
                    })
                });
               
                this.setState({
                    driverData:driverData
                })

                // let carData = [];
                // let driverData = [];
                // res.data.data.carInformationList.map((res)=>{
                //     carData.push({
                //         label:res.carNum,
                //         value:res.carNum,
                //         carId:res.carId
                //     })
                // })
                // res.data.data.driverInformationList.map((res)=>{
                //     driverData.push({
                //         label:res.driverName,
                //         value:res.driverName,
                //         driverId:res.driverId
                //     })
                // })
                // this.setState({
                //     carData:carData,
                //     driverData:driverData
                // })

            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg,3)
            }
        }).catch(function (error) {
        console.log(error);
    });
    }
    inputChange = (v,k) =>{
        this.setState({
            [v]:k
        })
    }
    driverActive = (k,v) =>{
        let driverData = this.state.driverData;
        let driverlabels = [];
        driverData.map(e =>{
            driverlabels.push(e.label)
        })
      
        this.setState({
            [v]:k,
            driverId:driverData[driverlabels.indexOf(k[0])].driverId,
        })
        let cardata = [];
        driverData[driverlabels.indexOf(k[0])].carInformationList.map(e =>{
            cardata.push({
                value:e.carNum,
                label:e.carNum,
                carId:e.carId
            })
        })
        this.setState({
            carData:cardata
        })
    }
    carActive = (k,v) =>{
        
        let carData = this.state.carData;
        let carlabels = [];
      
        carData.forEach(e =>{
            carlabels.push(e.label)
        })
        this.setState({
            [v]:k,
            carId:carData[carlabels.indexOf(k[0])].carId,
        })
    }
    confirmOrder = () =>{
        if(this.state.people == ''){
            Toast.info('人数不能为空！')
            return
        }
        if(this.state.price == ''){
            Toast.info('请输入价格！')
            return
        }
        if(this.state.price == 0){
            Toast.info('价格不能为0！')
            return
        }
        if(this.state.people > 8 || this.state.people < 1){
            Toast.info('人数不能大于8人或者小于1人！')
            return
        }
        if(this.state.driver == ''){
            Toast.info('请选择司机！')
            return
        }
        if(this.state.car == ''){
            Toast.info('请选择车辆！')
            return
        }
        let params = { 
            "token": this.props.userInfo.token,
            "data": {
                "id":this.props.location.shuntType.id,
                "totalPrice":this.state.price,
                "driverId":this.state.driverId,
                "carId":this.state.carId,
                "passagerNum":this.state.people
            }
        }
        console.log(params)
        confirmOrder(params).then((res) => {
            console.log(res)
            if (res.data.code === '0000') {
            Toast.info('操作成功！', 2, this.props.history.goBack());
            }
            else if (res.data.code === '1401') {
            document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
          }).catch(function (error) {
          console.log(error);
      });

    }
    backInvoice(item,type){
        Toast.loading('',0);
        let params = {
            token: this.props.userInfo.token,
            data: {id:item.id}
        };
        cancelRent(params).then((res) => {
            if (res.data.code === '0000') {
                if(type === 'refund'){
                    Toast.info("操作成功，请关注退款进度",2,()=>this.props.history.goBack());
                }else{
                    Toast.info("关闭成功，订单已取消！",2,()=>this.props.history.goBack());
                }
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    statusConfirm = (params,i) =>{
        // console.log(status)
        // if(status === 0){
        //     return <div className="btn" onClick={()=>this.confirmOrder()}>确认订单</div>
        // }
        if(params === 0){
            return <div className="btnContent"><div className="btn close" onClick={(e)=>{e.stopPropagation();
                Modal.alert('提示', '您确定要关闭吗?关闭订单前请务必与乘客协商！', [
                    { text: '取消'},
                    { text: '确定', onPress: () => this.backInvoice(i)},
                ])}}>关闭订单</div><div className="btn" onClick={()=>{this.confirmOrder()}}>确认订单</div></div>
        }
        if(params === 1){
            return <div className="btnContent"><div className="btn close" onClick={(e)=>{e.stopPropagation();
                Modal.alert('提示', '您确定要关闭吗?关闭订单前请务必与乘客协商！', [
                    { text: '取消'},
                    { text: '确定', onPress: () => this.backInvoice(i)},
                ])}}>关闭订单</div></div>
        }
        // if(params === 2){
        //     return <div className="btnContent"><div className="btn close"  onClick={(e)=>{e.stopPropagation();
        //         Modal.alert('提示', '您确定要退款吗？', [
        //             { text: '取消'},
        //             { text: '确定', onPress: () => this.backInvoice(i,'refund')},
        //         ])}}>退款</div></div>
        // }
        if(params === 3){
            return <div className="moli">该订单已在行程中</div>
        }
        if(params === 4){
            return <div className="moli">该订单已完成</div>
        }
        if(params === 99){
            return <div className="moli">该订单已取消</div>
        }

    }
    callPhone =(e,id)=>{
        e.stopPropagation()
        this.setState({
            showModal:true,
            orderId:id
        })
        
    }
    number=(id)=>{ 
        // let params = {
        //     token: this.props.userInfo.token,
        //     "data": {
        //         "id": id,
        //         orderSource:6,
        //     }
        // };
        // shuntFakeConverse(params).then((res) => {
        //     console.log(res)
        //     if (res.data.code === '0000') {
                window.location.href = "tel://" + id;
            // }
            // else if (res.data.code === '1401') {
            //     document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            // }
            // else {
            //     Toast.info(res.data.msg);
            // }
        // }).catch(function (error) {
        //     console.log(error);
        // });
    }
    render() {
        const props = this.props.location.shuntType;
        return (
            <div className="RentConfirm">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui"  onClick={() => this.props.history.goBack()}/>}
                >{props.status === 0 ? '订单确认':'订单详情'}</NavBar>
                <div className="content">
                    <div className="cardBox">
                        <div className="header" id={props.orderType === 0 ? "single" : (props.orderType === 1 ? "double" :"whole")}>
                            <div><span>{props.orderType === 0 ? '单程包车':(props.orderType === 1 ? "往返包车" : "按天包车")}</span></div>
                        </div>
                        <div className="body">
                            <div>
                                <div className="lineName">{props.lineName}</div>
                                <div className="people"><span className="padding38">{props.orderType === 0 ? '单程包车':(props.orderType === 1 ? "往返包车" : "按天包车")}</span><span>{this.state.people}人</span></div>
                                <div className="date"><span className="padding38">用车时间</span>{props.estimatedTimeOfDeparture}</div>
                            </div>
                            <div className="phone" onClick={(e)=>this.callPhone(e,props.phone)}><i className="i iconfont icondianhuatubiao" ></i></div>    
                        </div>
                    </div>
                    <div className="confirm">{props.status === 0 ? '订单确认':'订单详情'}</div>
                   
                    {
                        props.status === 0 ? 
                        <div> 
                            <InputItem
                            className="inp"
                            placeholder=""
                            maxLength={1}
                            value={this.state.people}
                            onChange={(v)=>this.inputChange("people",v)}
                            type="number"
                            ><span className="list">出行人数</span></InputItem>
                            <InputItem
                                className="inp"
                                placeholder="请输入订单价格"
                                moneyKeyboardAlign="left"
                                value={this.state.price}
                                onChange={(v)=>this.inputChange("price",v)}
                                type="money"
                            ><span className="list">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格</span></InputItem>
                            <List className="address">
                            <Picker
                                cols={1}
                                extra={'请选择司机'}
                                data={this.state.driverData}
                                value={this.state.driver}
                                onOk={(v,j) =>this.driverActive(v, 'driver')}
                            >
                                <List.Item arrow="horizontal"><span className="list">指派司机</span></List.Item>
                            </Picker>
                            <Picker
                                cols={1}
                                extra={'请选择车辆'}
                                data={this.state.carData}
                                value={this.state.car}
                                onOk={(v) =>this.carActive(v, 'car')}
                            >
                                <List.Item arrow="horizontal"><span className="list">指派车辆</span></List.Item>
                            </Picker>
                            <InputItem
                                className="inp"
                                placeholder=""
                                editable={false}
                                disabled={true}
                                value={props.description}
                                type="number"
                            ><span className="list">备注信息</span></InputItem>
                        </List>
                        <div className="footer">*请务必先与乘客协商后再进行订单确认</div></div> : 
                    <div className="footer2">
                        <InputItem
                            className="inp"
                            placeholder=""
                            maxLength={1}
                            editable={false}
                            disabled={true}
                            value={props.passagerNum}
                            type="number"
                        ><span className="list">出行人数</span></InputItem>
                        <InputItem
                            className="inp"
                            placeholder="请输入订单价格"
                            editable={false}
                            disabled={true}
                            value={props.totalPrice}
                            type="number"
                        ><span className="list">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格</span></InputItem>
                        <InputItem
                            className="inp"
                            placeholder=""
                            maxLength={1}
                            editable={false}
                            disabled={true}
                            value={props.driverName}
                            type="number"
                        ><span className="list">司机姓名</span></InputItem>
                        <InputItem
                            className="inp"
                            placeholder=""
                            maxLength={1}
                            editable={false}
                            disabled={true}
                            value={props.carNum}
                            type="number"
                        ><span className="list">车牌号码</span></InputItem>
                        <InputItem
                            className="inp"
                            placeholder=""
                            editable={false}
                            disabled={true}
                            value={props.description}
                            type="number"
                        ><span className="list">备注信息</span></InputItem>
                    </div>
                    }
                   {this.statusConfirm(props.status,props)} 
                   <Modal
                        className="combineBillViewModal"
                        visible={this.state.showModal}
                        transparent
                        maskClosable={false}
                        footer={[{ text: '否', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '是', onPress: () => { this.setState({showModal:!this.state.showModal});this.number(this.state.orderId) } }]}
                    >
                   <div className="modalTitle">
                       <div>是否确认拨打电话？</div>
                        {/*    <span>出于隐私保护，该号码为虚拟号码</span> */}
                   </div>
               </Modal>  
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/RentModule/RentConfirm/index.js